export const INIT_STATE = "SEARCH_INIT_STATE";
export const RESET_STATE = "SEARCH_RESET_STATE";
export const CURRENT_SELECTED = "SEARCH_CURRENT_SELECTED";

export const REQUEST_LOADING = "SEARCH_REQUEST_LOADING";
export const REQUEST_SUCCESS = "SEARCH_REQUEST_SUCCESS";
export const REQUEST_FAILED = "SEARCH_REQUEST_FAILED";

export const RESET_REF = "SEARCH_RESET_REF";
